import React from 'react';
import { useOutletContext, Link } from 'react-router-dom';

const AdminDashboard = () => {
  const { stats } = useOutletContext();

  const statCards = [
    { label: 'Destinations', value: stats?.destinations || 0, icon: 'fa-map-location-dot', color: '#0d9488', link: '/admin/destinations' },
    { label: 'Last Minute Deals', value: stats?.lastMinuteDeals || 0, icon: 'fa-fire', color: '#ef4444', link: '/admin/last-minute-deals' },
    { label: 'Early Bird Deals', value: stats?.earlyBirdDeals || 0, icon: 'fa-clock', color: '#f59e0b', link: '/admin/early-bird-deals' },
    { label: 'Handpicked', value: stats?.handpickedDestinations || 0, icon: 'fa-star', color: '#8b5cf6', link: '/admin/handpicked' },
    { label: 'Travel Stories', value: stats?.travelStories || 0, icon: 'fa-comments', color: '#3b82f6', link: '/admin/travel-stories' },
    { label: 'Contact Submissions', value: stats?.contactSubmissions || 0, icon: 'fa-envelope', color: '#10b981', link: '/admin/inquiries' },
    { label: 'Booking Inquiries', value: stats?.bookingInquiries || 0, icon: 'fa-calendar-check', color: '#ec4899', link: '/admin/inquiries' },
    { label: 'Promo Inquiries', value: stats?.promoInquiries || 0, icon: 'fa-gift', color: '#6366f1', link: '/admin/inquiries' },
  ];

  return (
    <div className="admin-dashboard">
      <div className="admin-page-header">
        <h1>Dashboard</h1>
        <p>Welcome to Elite Experiences Admin Panel</p>
      </div>

      <div className="admin-stats-grid">
        {statCards.map((stat, index) => (
          <Link to={stat.link} key={index} className="admin-stat-card" style={{ '--accent-color': stat.color }}>
            <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
              <i className={`fa-solid ${stat.icon}`}></i>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          </Link>
        ))}
      </div>

      <div className="admin-quick-actions">
        <h2>Quick Actions</h2>
        <div className="quick-actions-grid">
          <Link to="/admin/destinations" className="quick-action-btn">
            <i className="fa-solid fa-plus"></i>
            Add Destination
          </Link>
          <Link to="/admin/last-minute-deals" className="quick-action-btn">
            <i className="fa-solid fa-plus"></i>
            Add Deal
          </Link>
          <Link to="/admin/travel-stories" className="quick-action-btn">
            <i className="fa-solid fa-plus"></i>
            Add Story
          </Link>
          <Link to="/admin/settings" className="quick-action-btn">
            <i className="fa-solid fa-gear"></i>
            Site Settings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
